module.exports = __webpack_public_path__ + "img/banner-line_short_orange.bf12a536.png";